import React, { useState, useEffect, useRef } from 'react';
import './header.css';
import menuIcon from "../../ui/assets/images/menu-icon.png";
import { useNavigate, useLocation } from 'react-router-dom';
import { removeUserCredentials } from "../Utils/authUtils"
import { useTheme } from '../../ui/src/contextProviders';
import { Icon, ICONS, Tooltip } from '@ohif/ui';
import { NavLink } from 'react-router-dom';
// import '../global.css'
import { _auditUrls } from '@custom/Utils/constants/apiUrls';
import { permissionState } from '@custom/Utils/constants/permission';
import { _routes } from '../Utils/constants/routes';
import "../custom.css"
import { HeaderProps } from '@custom/Utils/constants/interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import getNotificationCount from '@custom/rtk-apis/report/notificationCount';
import { _roleType } from '@custom/Utils/constants/appConstants';
import getDiscountRequestsApi from '@custom/rtk-apis/billing/discountNotification/getDiscountRequests';
import { graceperiod } from '@custom/constant';

const capitalizeName = (name: string) => {
  return name.replace(/\b\w/g, char => char.toUpperCase());
};

const getInitials = (name: string) => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
};

const formatRoleLabel = (role: string | null): string => {
  if (!role) return '';
  switch (role) {
    case 'hospitalsuperadmin':
    case 'Superadmin':
      return 'Superadmin';
    case 'Radiologist Admin':
      return 'Radiologist Admin';
    case 'Pathologist Admin':
      return 'Pathologist Admin';
    case 'Front Desk':
      return 'Front Desk';
    default:
      // Capitalize first letter of each word
      return role.replace(/\b\w/g, char => char.toUpperCase());
  }
};

const getProfileRoute = (role: string | null, userId: string | null): string => {
  if (role === 'Superadmin' || role === 'superadmin') return '/myprofile';
  if (role === 'hospitalsuperadmin') return '/edithospital';
  if (role === 'teraradiologysuperadmin') return '/editTeleradiology';
  return _routes.user.detailsWithId(userId);
};

const getDepartmentLabel = (role: string | null): string => {
  switch (role) {
    case 'Radiologist':
    case 'Radiologist Admin':
    case 'Resident':
      return 'Department of Radiology';
    case 'Pathologist':
    case 'Pathologist Admin':
      return 'Department of Pathology';
    case 'Technician':
      return 'Department of Radiology';
    case 'Admin':
    case 'hospitalsuperadmin':
      return 'Administration';
    case 'Front Desk':
      return 'Reception';
    default:
      return 'Department of General Medicine';
  }
};

const Header = ({ title, isBack, handleIsBackFunctionality }: HeaderProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { status, result, msg, loading, error } = useSelector((state: RootState) => state?.getNotificationCountResponse);
  const getDiscountRequestsData = useSelector((state: RootState) => state.getDiscountRequestsResponse);
  const { isDarkMode, toggleTheme } = useTheme();
  const [userName, setUserName] = useState<string | null>(null);
  const [profilePic, setProfilePic] = useState<string>('');
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const overlayRef = useRef(null);
  const [activeLink, setActiveLink] = useState(null);
  const [menu, setMenu] = useState([])
  const [showDropdown, setShowDropdown] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showSettingsInDropdown, setShowSettingsInDropdown] = useState(false);
  const location = useLocation();
  const [pendingDiscountReqCount, setPendingDiscountReqCount] = useState(0);
  const storedUserRole = sessionStorage.getItem('role') || localStorage.getItem('role');
  const storedUserId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
  const hospitalDetailsData = useSelector((state: RootState) => state?.hospitalDetailsResponse);

  useEffect(() => {
    // Fetch the user name from sessionStorage
    const storedUserName = sessionStorage.getItem('name') || localStorage.getItem('name');
    const storedUserId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
    if (storedUserName) {
      setUserName(capitalizeName(storedUserName));
    } else {
      setUserName('Guest');
    }
    const storedProfilePic = sessionStorage.getItem('profilePic') || localStorage.getItem('profilePic') || '';
    setProfilePic(storedProfilePic);
    const storedUserRole = sessionStorage.getItem('role') || localStorage.getItem('role');
    const hospitalType = sessionStorage.getItem("hospitalType") || localStorage.getItem('hospitalType');
    let roleToCheck = hospitalType === 'teraradiology' && (storedUserRole === 'Resident' || storedUserRole === 'Radiologist') ? 'teleradiologistUser' : storedUserRole ? storedUserRole.replace(/\s+/g, '').toLowerCase() : null;
    // Add a case in case of telepathologist
    if (hospitalType == "teraradiology" && storedUserRole == _roleType.pathologist) {
      roleToCheck = 'telepathologist';
    } else if (hospitalType == "teraradiology" && storedUserRole == _roleType.radiologistAdmin) {
      roleToCheck = 'radiologistAdmin';
    } else if (hospitalType == "teraradiology" && storedUserRole == _roleType.pathologistAdmin) {
      roleToCheck = 'pathologistAdmin';
    }
    if(hospitalDetailsData?.result?.subscriptionDetail?.daysLeftForExpiration < graceperiod && storedUserRole === _roleType.hospitalSuperadmin){
      setMenu([{
        iconName: "user-side-menu",
        redirectTo: '/edithospital',
        routeName: 'Clinic / Hospital Profile'
      }])
    } else {
      let tempArray = permissionState[roleToCheck]?.navLink
      setMenu(tempArray)
    }

    dispatch(getNotificationCount());
  }, [hospitalDetailsData?.result]);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const subRouteParentMap: Record<string, string> = React.useMemo(() => {
    const map: Record<string, string> = {};
    menu?.forEach(item => {
      if (item.subMenu) {
        item.subMenu.forEach(sub => {
          map[sub.redirectTo] = item.redirectTo;
        });
      }
    });
    return map;
  }, [menu]);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false)
  }
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  const redirectToPage = (route) => {
    setActiveLink(route)
    setIsMenuOpen(false)
    navigate(route)

  }
  const logout = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('hospitalCode');
    localStorage.removeItem('hospitalType');
    removeUserCredentials();

    localStorage.setItem("isLightMode", "true");
    localStorage.setItem("selectedTheme", "light");

    const body = document.body;
    body.classList.remove('dark-theme');
    body.classList.add('light-theme');

    if (typeof toggleTheme === 'function' && isDarkMode) {
      toggleTheme();
    }

    setIsMenuOpen(false);
    navigate("/login");

  }
  const handleClickOutSide = (event) => {

    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
      setIsMenuOpen(false)
    }
  }

  useEffect(() => {
    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutSide)
    }
  }, [isMenuOpen])

  const handleBackClickButton = () => {
    if (isBack && handleIsBackFunctionality) {
      handleIsBackFunctionality();
    } else if (isBack) {
      if (title === "Edit Teleradiology Profile") {
        window.location.reload();
      } else if (window.history.length > 1) {
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    const body = document.body;
    if (!isDarkMode) {
      // Remove dark theme and add light theme
      body.classList.remove('dark-theme');
      body.classList.add('light-theme');
    } else {
      // Remove light theme and add dark theme
      body.classList.remove('light-theme');
      body.classList.add('dark-theme');
    }
    localStorage.setItem("isLightMode", isDarkMode ? String(false) : String(true));
    localStorage.setItem("selectedTheme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  useEffect(() => {
    dispatch(getDiscountRequestsApi()).unwrap()
  }, []);

  useEffect(() => {
    if (getDiscountRequestsData?.status === "success") {
      const pendingRequests = getDiscountRequestsData?.result?.filter(request => request?.discountRequest?.status === "Pending");
      setPendingDiscountReqCount(pendingRequests?.length);
    }
  }, [getDiscountRequestsData]);

  return (
    <div className="page__head ">
      <div className="page__head__colLeft">
        <button className="menu-button" onClick={toggleMenu}>
          <img style={
            isDarkMode ? { filter: 'invert(1)' } : null
          } src={menuIcon}></img>
        </button>
        <div className='page__head--title'>
          {isBack && <img onClick={handleBackClickButton} style={
            isDarkMode ? { filter: 'invert(1)' } : null
          } src={ICONS.back} />}
          {title}
        </div>
        <div className="layoutSidemenu__logo">
          {/* <div className='hospitalLogoBox'>
            <img className='hospitalLogo' src={ICONS.HospitalLogo} alt="Hospital Logo" />
          </div> */}
          <div className='logoMain'>
            <img src={ICONS.SevenHillsLogo} alt="Logo | Seven Hills" />
            <p className='departmentInfo'>{getDepartmentLabel(storedUserRole)}</p>
          </div>
        </div>

      </div>

      <div ref={overlayRef} className={`layoutSidemenu ${(isMenuOpen || isHovered) ? 'layoutSidemenu--open' : ''}`} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>

        <div className="layoutSidemenu__fullHeight">
          <ul className="layoutSidemenu__list">
            {menu?.filter(item => item.routeName !== 'Settings').map((item, index) => (
              <li key={index}>
                <Tooltip content={item.routeName} position="right" showBorder boldText hideStrip offset={-10}>
                <div
                  className={`layoutSidemenu__list--item ${(item.routeName !== 'Settings' && (item.redirectTo === '/' ? activeLink === '/' : activeLink?.startsWith(item.redirectTo) || subRouteParentMap[activeLink] === item.redirectTo)) ||
                    (item.routeName === 'Settings' && (activeLink === '/settings/reports' || activeLink === '/machines' || activeLink === '/frontdeskmachine' || activeLink === '/pacs'))
                    ? 'layoutSidemenu__selected'
                    : ''
                    }`} onClick={() => {
                      if (item.routeName === 'Settings') {
                        setShowDropdown(!showDropdown);
                        //  setActiveLink(item.redirectTo)
                      } else {
                        redirectToPage(item.redirectTo);
                      }
                    }}
                >
                  {item.routeName === 'Settings' ? (
                    <div className="layoutSidemenu__list--link flex items-center justify-between" style={{ justifyContent: 'space-between' }} title={item.routeName}>
                      <div className='flex items-center'>
                        <span className="icon mr-2">
                          <Icon name={item.iconName}></Icon>
                        </span>
                        {item.routeName}
                      </div>
                      <span className="icon chevron-icon" style={{ transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                        <Icon name="chevron-down"></Icon>
                      </span>
                    </div>
                  ) : (
                    <NavLink
                      className="layoutSidemenu__list--link flex items-center justify-between"
                      to={item.redirectTo}
                      style={{ justifyContent: 'space-between' }}
                      title={item.routeName}
                    >
                      <div className="flex items-center">
                        <div className="flex items-center mr-5">
                          <span className="icon mr-2">
                            <Icon name={item.iconName}></Icon>
                          </span>
                          <p>{item.routeName}</p>
                        </div>
                        {item.routeName === "My Worklist" && result?.notificationCount > 0 && (
                          <div className="badge">
                            <p>{result?.notificationCount}</p>
                          </div>
                        )}
                        {item.routeName === "Discount Requests" && pendingDiscountReqCount > 0 && (
                          <div className="badge">
                            <p>{pendingDiscountReqCount}</p>
                          </div>
                        )}
                      </div>
                    </NavLink>
                  )}
                </div>
                </Tooltip>
                {/* Sub-menu Dropdown */}
                {item.routeName === 'Settings' && showDropdown && (
                  <ul className="layoutSidemenu__dropdown">
                    {item.subMenu.map((subItem, subIndex) => (
                      <li
                        key={subIndex}
                        className={`layoutSidemenu__list--item ${activeLink === subItem.redirectTo ? 'layoutSidemenu__selected' : ''
                          }`}

                      >
                        <Tooltip showBorder boldText hideStrip content={subItem.routeName} position="right">
                          <NavLink
                            className="layoutSidemenu__list--link flex items-center justify-between"
                            to={subItem.redirectTo}
                            onClick={() => redirectToPage(subItem.redirectTo)}
                          >
                            <div className='flex items-center'>
                              {subItem.routeName}
                            </div>
                          </NavLink>
                        </Tooltip>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}

          </ul>
        </div>
      </div>
      <div className="page__head__colRight">
        {result?.notificationCount > 0 && location.pathname !== '/worklist' && (storedUserRole === 'Radiologist' || storedUserRole === 'Pathologist') && (
          <div className="notification-count" style={{ marginRight: '10px' }}>
            <span style={{ color: isDarkMode ? '#fff' : '#006400' }}>Review Report: {result.notificationCount}</span>
          </div>
        )}
        {storedUserRole !== 'Radiologist' && (
          pendingDiscountReqCount > 0 && (
            <div className="notification-count" style={{ marginRight: '10px' }}>
              <span style={{ color: isDarkMode ? '#fff' : '#006400' }}>Pending Discount Request: {pendingDiscountReqCount}</span>
            </div>
          )
        )}
        <label className="inline-flex items-center cursor-pointer mt-0 switchButton">
  <input
    type="checkbox"
    value=""
    checked={isDarkMode}
    className="sr-only peer"
    onChange={toggleTheme}
  />
  <div
    className="relative w-11 h-6 rounded-full peer
      after:content-[''] after:absolute after:top-[2px] after:left-[2px]
      after:bg-white after:border-gray-300 after:border after:rounded-full
      after:h-5 after:w-5 after:transition-all
      peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
      peer-checked:after:border-white"
    style={{
      backgroundColor: isDarkMode ? '#51A196' : '#999999',
    }}
  ></div>
</label>
        <button className="user-button" onClick={() => setShowUserDropdown(prev => !prev)}>
          {profilePic ? (
            <img
              src={profilePic}
              alt="Profile"
              style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
            />
          ) : (
            <div style={{
              width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#51A196',
              color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '13px', fontWeight: 600, flexShrink: 0
            }}>
              {getInitials(userName)}
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2 }}>
            <span>{userName}</span>
            <span style={{ fontSize: '11px', opacity: 0.8 }}>{formatRoleLabel(storedUserRole)}</span>
          </div>
          <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.5 0.5L5.5 5.5L10.5 0.5" stroke="#111111" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        {showUserDropdown && <div className="user-dropdown">
          <div className='userProfile'>
            <div className='userProfile__pic'>
              {/* <img src='./assets/images/user.png' alt="User Profile" /> */}
              {getInitials(userName)}
            </div>
            <div className='userProfile__info'>
              <h3>{userName}{isDarkMode}</h3>
              <p>{formatRoleLabel(storedUserRole)}</p>
            </div>
          </div>
          <div className='userProfile__actions'>
            <ul className='userProfile__actions__list'>
              <li>
                <NavLink to={getProfileRoute(storedUserRole, storedUserId)}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.10671 7.24732C8.04004 7.24065 7.96004 7.24065 7.88671 7.24732C6.30004 7.19398 5.04004 5.89398 5.04004 4.29398C5.04004 2.66065 6.36004 1.33398 8.00004 1.33398C9.63337 1.33398 10.96 2.66065 10.96 4.29398C10.9534 5.89398 9.69337 7.19398 8.10671 7.24732Z" stroke="#333333" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M4.77335 9.70602C3.16002 10.786 3.16002 12.546 4.77335 13.6193C6.60669 14.846 9.61335 14.846 11.4467 13.6193C13.06 12.5393 13.06 10.7793 11.4467 9.70602C9.62002 8.48602 6.61335 8.48602 4.77335 9.70602Z" stroke="#333333" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Profile
                </NavLink>
              </li>
              {menu?.some(item => item.routeName === 'Settings') && <li>
                <div
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
                  onClick={() => setShowSettingsInDropdown(prev => !prev)}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                      <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="#333333" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M1.33337 8.5863V7.41297C1.33337 6.71963 1.90004 6.1463 2.60004 6.1463C3.80671 6.1463 4.30004 5.29297 3.69337 4.2463C3.34671 3.6463 3.55337 2.8663 4.16004 2.51963L5.31337 1.85963C5.84004 1.5463 6.52004 1.73297 6.83337 2.25963L6.90671 2.3863C7.50671 3.43297 8.49337 3.43297 9.10004 2.3863L9.17337 2.25963C9.48671 1.73297 10.1667 1.5463 10.6934 1.85963L11.8467 2.51963C12.4534 2.8663 12.66 3.6463 12.3134 4.2463C11.7067 5.29297 12.2 6.1463 13.4067 6.1463C14.1 6.1463 14.6734 6.71297 14.6734 7.41297V8.5863C14.6734 9.27963 14.1067 9.85297 13.4067 9.85297C12.2 9.85297 11.7067 10.7063 12.3134 11.753C12.66 12.3596 12.4534 13.133 11.8467 13.4796L10.6934 14.1396C10.1667 14.453 9.48671 14.2663 9.17337 13.7396L9.10004 13.613C8.50004 12.5663 7.51337 12.5663 6.90671 13.613L6.83337 13.7396C6.52004 14.2663 5.84004 14.453 5.31337 14.1396L4.16004 13.4796C3.55337 13.133 3.34671 12.353 3.69337 11.753C4.30004 10.7063 3.80671 9.85297 2.60004 9.85297C1.90004 9.85297 1.33337 9.27963 1.33337 8.5863Z" stroke="#333333" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Settings
                  </div>
                  <svg
                    width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg"
                    style={{ transition: 'transform 0.2s', transform: showSettingsInDropdown ? 'rotate(180deg)' : 'rotate(0deg)' }}
                  >
                    <path d="M0.5 0.5L5.5 5.5L10.5 0.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                {showSettingsInDropdown && (
                  <ul className='submenu'>
                    {(menu?.find(item => item.routeName === 'Settings')?.subMenu || []).map((subItem, idx) => (
                      <li key={idx}>
                        <NavLink
                          to={subItem.redirectTo}
                          onClick={() => { redirectToPage(subItem.redirectTo); setShowUserDropdown(false); }}
                        >
                          {subItem.routeName}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>}
            </ul>
          </div>
          <div className="userProfile__logout">
            <h4 className="userProfile__logout__title" style={{ cursor: 'pointer' }} onClick={logout}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.6267 9.74732L13.3334 8.04065L11.6267 6.33398" stroke="#E86E66" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.50671 8.03906H13.2867" stroke="#E86E66" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.84005 13.3327C4.89338 13.3327 2.50671 11.3327 2.50671 7.99935C2.50671 4.66602 4.89338 2.66602 7.84005 2.66602" stroke="#E86E66" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Logout
            </h4>
          </div>
        </div>}
      </div>

    </div>
  );
};

export default Header;
